/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
   * SEO: Stamped Reviews renderiza los títulos de reseña como <h3>, lo que
   * ensucia el outline de encabezados de la página de producto. Stamped no
   * expone una opción para cambiar el tag, así que reescribimos cada <h3>
   * dentro de sus widgets a <p>, conservando clases, id, atributos y contenido.
   *
   * El widget se inyecta por JS de forma asíncrona, por eso usamos un
   * MutationObserver además de una pasada inicial.
   */
  (function downgradeStampedHeadings() {
    // Contenedores conocidos del widget de Stamped (main widget, carousel, badge).
    var CONTAINER_SELECTOR =
      '#stamped-main-widget, .stamped-container, .stamped-reviews-widget, ' +
      '[id^="stamped-"], [class^="stamped-"], [class*=" stamped-"]';

    function convertHeading(h3) {
      if (!h3 || h3.dataset.seoDowngraded === 'true') return;

      var p = document.createElement('p');

      // Copiar todos los atributos (class, id, data-*, style, etc.).
      for (var i = 0; i < h3.attributes.length; i++) {
        var attr = h3.attributes[i];
        p.setAttribute(attr.name, attr.value);
      }

      p.innerHTML = h3.innerHTML;
      p.dataset.seoDowngraded = 'true';
      h3.parentNode.replaceChild(p, h3);
    }

    function scan(root) {
      var containers = (root || document).querySelectorAll(CONTAINER_SELECTOR);
      for (var i = 0; i < containers.length; i++) {
        var h3s = containers[i].querySelectorAll('h3');
        for (var j = 0; j < h3s.length; j++) {
          convertHeading(h3s[j]);
        }
      }
    }

    function init() {
      scan(document);

      var observer = new MutationObserver(function(mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var k = 0; k < added.length; k++) {
            if (added[k].nodeType === 1) {
              scan(added[k].parentNode || document);
            }
          }
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
